import { useEffect, useMemo } from 'react'

import { CombinedLogs, useGetMileagePeriod } from '@/modules/CombinedLogs'
import { FindGarage } from '@/modules/FindGarage/ui/FindGarage'
import { useGarageStore } from '@/modules/FindGarage'
import { DateInputMileage } from '@/components/DateInput'
import { useInitMileageClerkSession } from '../hooks/useInitMileageClerkSession'
import { useCalculateAmountOfFitRoutes } from '@/modules/Workstation/hooks/useCalculateAmountOfFitRoutes'
import { sortRoutes } from '../helpers/sortRoutes'
import { Loader } from '@/ui/Loader'
import { RoutesFilter } from './components/RoutesFilter'

import commonStyles from './Dashboard.module.scss'
import styles from './MileageClerkDashboard.module.scss'

import { Mileage } from '@/modules/Mileage'

export const MileageClerkDashboard = () => {
    const { garage, selectedRoutes } = useGarageStore()
    const { isPending: isMileagePeriodPending } = useGetMileagePeriod()
    const init = useInitMileageClerkSession()

    const { containerRef, fitCount } = useCalculateAmountOfFitRoutes({
        totalItems: isMileagePeriodPending ? 0 : selectedRoutes.length,
        isEditable: true,
        editorWidth: 150,
        isExcludedElement: (element) => 'popup' in element.dataset,
    })

    const routes = useMemo(() => {
        if (!garage) {
            return []
        }

        const sorted = sortRoutes(selectedRoutes, garage.routes)

        return sorted.slice(0, fitCount)
    }, [garage, selectedRoutes, fitCount])

    const hiddenCount = useMemo(() => {
        if (selectedRoutes.length < routes.length) {
            return 0
        }

        const count = selectedRoutes.length - routes.length

        return count > 0 ? count : 0
    }, [selectedRoutes.length, routes.length])

    useEffect(() => {
        init()
    }, [])

    if (!garage) {
        return <FindGarage />
    }

    if (isMileagePeriodPending) {
        return (
            <section className={commonStyles.root}>
                <Loader />
            </section>
        )
    }

    return (
        <section className={commonStyles.root}>
            <div className={commonStyles.header}>
                <div className={styles.info}>
                    <DateInputMileage />
                    <div ref={containerRef} className={styles.routes}>
                        {routes.map((route) => (
                            <div key={route} className={styles.route}>
                                {route}
                            </div>
                        ))}
                        {!!hiddenCount && <span className={styles.hiddenCount}>+{hiddenCount}</span>}
                        <RoutesFilter />
                    </div>
                </div>
                <Mileage displayed={routes.length > 0} />
            </div>

            <CombinedLogs />
        </section>
    )
}
